import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export class CostHintSelect {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsNumber()
  count!: number;
}
